import type { ReactNode } from "react";
import { C } from "../tokens";

interface Tab { id: string; label: string; count?: number; icon?: ReactNode }

interface Props {
  tabs: Tab[];
  active: string;
  onChange: (id: string) => void;
}

export function Tabs({ tabs, active, onChange }: Props) {
  return (
    <div
      style={{
        display: "flex",
        gap: 4,
        padding: 4,
        background: C.surface,
        border: `1px solid ${C.border}`,
        borderRadius: 12,
        overflowX: "auto",
      }}
    >
      {tabs.map((t) => {
        const on = t.id === active;
        return (
          <button
            key={t.id}
            onClick={() => onChange(t.id)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 12px",
              fontSize: 11,
              fontWeight: 600,
              color: on ? C.blue : C.textSub,
              background: on ? C.blueDim : "transparent",
              border: `1px solid ${on ? C.borderBright : "transparent"}`,
              borderRadius: 8,
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "background 0.15s, color 0.15s",
            }}
          >
            {t.icon}
            {t.label}
            {typeof t.count === "number" && (
              <span
                style={{
                  padding: "0 5px", borderRadius: 4,
                  background: on ? C.blueMid : C.surfaceMid,
                  color: on ? C.blue : C.textMuted,
                  fontSize: 9, fontWeight: 700,
                }}
              >
                {t.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
